/* Keep this enhancement separate from Broadcast's header and mobile scripts. */
if (!customElements.get('pc-compact-menu')) {
  customElements.define('pc-compact-menu', class extends HTMLElement {
    connectedCallback() {
      this.owner = this.closest('hover-disclosure');
      this.dropdown = this.closest('.header__dropdown');
      this.anchor = this.owner?.querySelector('[data-top-link]');
      if (!this.owner || !this.dropdown || !this.anchor) return;
      this.groups = Array.from(this.querySelectorAll('.pc-nav-group'));
      this.onClick = (event) => {
        const summary = event.target.closest('.pc-nav-group__toggle');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const group = summary.parentElement;
        const opening = !group.open;
        this.groups.forEach(item => { item.open = opening && item === group; });
        this.layout();
      };
      this.onKey = (event) => {
        const group = event.target.closest('.pc-nav-group');
        if (event.key === 'ArrowRight' && group && !group.open) {
          event.preventDefault();
          this.groups.forEach(item => { item.open = item === group; });
          this.layout();
          group.querySelector('.pc-nav-group__links a')?.focus();
        } else if (event.key === 'Escape' || (event.key === 'ArrowLeft' && group?.open)) {
          event.preventDefault();
          event.stopPropagation();
          this.handledEscape = event.key === 'Escape';
          const open = this.groups.find(item => item.open);
          if (open) {
            open.open = false;
            open.querySelector('summary').focus();
            this.layout();
          } else {
            this.anchor.focus();
            this.owner.dispatchEvent(new CustomEvent('theme:disclosure:hide'));
          }
        }
      };
      this.onKeyUp = (event) => {
        if (event.key === 'Escape' && this.handledEscape) {
          event.stopPropagation();
          this.handledEscape = false;
        }
      };
      this.onResize = () => {
        if (this.owner.getAttribute('aria-expanded') === 'true') this.layout();
      };
      this.onOutside = (event) => {
        if (!this.owner.contains(event.target) && this.owner.getAttribute('aria-expanded') === 'true') {
          this.owner.dispatchEvent(new CustomEvent('theme:disclosure:hide'));
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onResize, {passive: true});
      document.addEventListener('pointerdown', this.onOutside);
      this.observer = new MutationObserver(() => {
        if (this.owner.getAttribute('aria-expanded') !== 'true') {
          this.groups.forEach(item => { item.open = false; });
        }
        this.layout();
      });
      this.observer.observe(this.owner, {attributes: true, attributeFilter: ['aria-expanded']});
      this.layout();
    }
    layout() {
      const edge = 12;
      const viewport = document.documentElement.clientWidth;
      const mainWidth = Math.min(300, viewport - edge * 2);
      const panelWidth = Math.min(320, Math.max(0, viewport - edge * 2 - mainWidth));
      const open = this.groups.find(item => item.open);
      const anchor = this.anchor.getBoundingClientRect();
      const baseLeft = Math.max(edge, Math.min(anchor.left, viewport - mainWidth - edge));
      const opensLeft = Boolean(open && baseLeft + mainWidth + panelWidth > viewport - edge && baseLeft >= panelWidth + edge);
      const width = mainWidth + (open ? panelWidth : 0);
      const desiredLeft = opensLeft ? baseLeft - panelWidth : baseLeft;
      const left = Math.max(edge, Math.min(desiredLeft, viewport - width - edge));
      const containing = this.dropdown.offsetParent;
      const origin = containing ? containing.getBoundingClientRect().left + containing.clientLeft - containing.scrollLeft : 0;
      this.owner.classList.toggle('pc-opens-left', opensLeft);
      const values = {
        '--pc-main-width': mainWidth,
        '--pc-panel-width': panelWidth,
        '--pc-dropdown-width': width,
        '--pc-dropdown-left': left - origin,
        '--pc-main-offset': opensLeft ? panelWidth : 0,
        '--pc-panel-left': opensLeft ? 0 : mainWidth,
      };
      Object.entries(values).forEach(([key, value]) => this.owner.style.setProperty(key, `${value}px`));
      const panel = open?.querySelector('.pc-nav-group__links');
      this.owner.style.setProperty('--pc-panel-height', `${panel ? panel.scrollHeight : 0}px`);
      const top = this.dropdown.getBoundingClientRect().top;
      this.owner.style.setProperty('--pc-max-height', `${Math.max(80, window.innerHeight - top - edge)}px`);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onResize);
      document.removeEventListener('pointerdown', this.onOutside);
    }
  });
}
